import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import AuthService from "services/auth";
import { login } from "store/actions/auth";
import Constants from "app_constants";
import Utils from "utils";
import LoginView from "./view";

class Login extends Component {
  state = {
    email: "",
    password: "",
    error: false,
  };

  login = () => {
    const { email, password } = this.state;
    const { login } = this.props;

    if (!Utils.validator(email) || !Utils.validator(password)) {
      this.setState({
        error: Constants.errors.auth,
      });
    } else {
      AuthService.login({ email, password }).then((res) => {
        if (res && res.id) {
          login(res);
          this.props.history.push("/");
        } else {
          this.setState({ error: Constants.errors.auth });
        }
      });
    }
  };

  setFormData = (type, value) => this.setState({ [type]: value });

  render() {
    const { email, password, error } = this.state;
    return (
      <LoginView
        error={error}
        email={email}
        password={password}
        login={this.login}
        setFormData={this.setFormData}
      />
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user,
});

const mapDispatchToProps = (dispatch) => ({
  login: (id) => dispatch(login(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));
